import { render, staticRenderFns } from "./VMTextarea.vue?vue&type=template&id=3d938709&scoped=true&lang=pug&"
import script from "./VMTextarea.vue?vue&type=script&lang=js&"
export * from "./VMTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d938709",
  null
  
)

export default component.exports